import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_event/$eventSlug/jornadas/')({
  beforeLoad: () => {
    throw redirect({
      to: '/jornadas',
      replace: true
    })
  }
})
